import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import ContextMenu from './ContextMenu'
import { FacebookButton, TwitterButton, LinkedInButton } from 'react-social'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { Utils } from '../../legacy'
import Browser from 'aria-viewer/utils/mobileDetect'
import { SHARE_MENU } from '../contextMenuActions'
import { FRONT, FRONT_INDEX, LEFT, LEFT_INDEX, RIGHT, RIGHT_INDEX } from 'aria-viewer/navigation/navigationActions'
import { openModal } from 'aria-viewer/modal/modalActions'
import { MENU_SHARE_MENU_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'
import { MEDIA_TYPES, SHARE_TYPES } from 'aria-viewer/tour/constants'
import ModalTypes from 'aria-viewer/modal/constants/ModalTypes'
import { asHybridButton } from 'aria-viewer/utils/hybridButton'
import $ from 'jquery'
import { getEnv } from 'aria-viewer/utils/environment'

const iconStyle = style => {
    return Object.assign(
        {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
        style
    )
}
class ShareContextMenu extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            includeYouVisitHashtag: true,
            /*
             * Locations exempt from YouVisit Hashtag, per agreement with Sales.
             * TODO: API Driven.
             */
            locsExemptFromHashTag: [139491],
        }
        this.showEmailForm = this.showEmailForm.bind(this)
        this.showLinkForm = this.showLinkForm.bind(this)
        this.showTouchShare = this.showTouchShare.bind(this)
        this.hideTouchShare = this.hideTouchShare.bind(this)
        this.showMouseDownShare = this.showMouseDownShare.bind(this)
        this.getItemStyle = this.getItemStyle.bind(this)
    }
    init(props) {
        this.setState({
            url: this.generateTourURL(props),
            includeYouVisitHashtag: !this.state.locsExemptFromHashTag.includes(this.props.location.loc_id),
        })
    }
    componentWillMount() {
        this.init(this.props)
    }
    componentWillReceiveProps(nextProps) {
        this.init(nextProps)
    }
    getOrientation(navigation) {
        switch (navigation.get('orientation')) {
            case FRONT:
                return FRONT_INDEX
            case LEFT:
                return LEFT_INDEX
            case RIGHT:
                return RIGHT_INDEX
        }
    }
    generateTourURL({ location, trail, trailsList, pointIndex, navigation, currentPoint, language, tourid }) {
        var owner_id = location.inst_unique_id || location.owner_id
        var tourbase = window.location.pathname.indexOf('/tour') == 0 ? 'tour/' : ''
        var shareBaseURL = `${window.location.origin}/${tourbase}${owner_id}/${location.loc_id}`
        const isEmbededTour = window.location.href.indexOf('pl=v') != -1

        const orientation = this.getOrientation(navigation)
        const currentLanguage = language.getIn(['current', 'language'])

        const direction = 1 //TODO: find when direction changes

        const embed = isEmbededTour
            ? {
                  pl: 'v',
                  m_prompt: 1,
              }
            : {}

        const params = {
            loc:
                trailsList[0].trailid !== trail.trailid || trail.startPoint !== pointIndex
                    ? `${trail.trailid}:${pointIndex}:${orientation}:${direction}`
                    : '',
            language: currentLanguage == 'English' ? '' : currentLanguage,
            tourid: trailsList.length > 1 ? tourid : '',
            ...embed,
        }

        return [
            shareBaseURL,
            '?',
            Object.keys(params)
                .map(param => (params[param] ? `${param}=${params[param]}` : ''), '')
                .filter(_ => _)
                .join('&'),
        ].join('')
    }
    showEmailForm() {
        const { openModal, location, mainMedia, share } = this.props

        const imageUrl =
            mainMedia.mediaType == MEDIA_TYPES.video
                ? 'http://www.youvisit.com/public/assets/img/institutions/' + location.owner_id + '/embed/2.jpg'
                : mainMedia.urls.large

        Utils.generateTinyURL(this.state.url, url => {
            openModal(ModalTypes.FORM, {
                url: `${getEnv('REACT_APP_BASE_URL')}/main/Ajax/submitShareEmail`,
                title: 'Share by Email',
                subtitle: '* Required fields',
                fields: [
                    {
                        id: 'tourName',
                        type: 'hidden',
                        value: location.inst_name,
                    },
                    {
                        id: 'tourUrl',
                        type: 'hidden',
                        value: url,
                    },
                    {
                        id: 'imageUrl',
                        type: 'hidden',
                        value: imageUrl,
                    },
                    {
                        id: 'name',
                        type: 'text',
                        placeholder: 'Your Name*',
                    },
                    {
                        id: 'email',
                        type: 'text',
                        placeholder: 'Recipient Email*',
                    },
                    {
                        id: 'message',
                        type: 'textarea',
                        placeholder: 'Message',
                    },
                ],
                submit: {
                    label: 'Send',
                    action: 'submitForm',
                },
                captcha: {
                    enable: true,
                },
            })
        })
    }
    showLinkForm() {
        const { openModal, share, location, media, contextMenu } = this.props
        const mediaType = media?.mediaType
        const owner_id = location.inst_unique_id || location.owner_id
        const shareUrlId = contextMenu.get('shareUrlId')

        const MEDIA_URLS = {
            [MEDIA_TYPES.photo]: `${process.env.REACT_APP_BASE_URL}/tour/photos/${owner_id}/${location.loc_id}?id=${shareUrlId}`,
            [MEDIA_TYPES.panorama]: `${process.env.REACT_APP_BASE_URL}/tour/panoramas/${owner_id}/${location.loc_id}?id=${shareUrlId}`,
            [MEDIA_TYPES.video]: `${process.env.REACT_APP_BASE_URL}/tour/videos/${owner_id}/${location.loc_id}?id=${shareUrlId}`,
        }

        let mediaShareUrl = ''
        if (shareUrlId) {
            mediaShareUrl = MEDIA_URLS[mediaType]
        } else {
            mediaShareUrl = this.state.url
        }

        Utils.generateTinyURL(mediaShareUrl, url => {
            openModal(ModalTypes.FORM, {
                title: Browser.mobile() ? 'Select and Copy' : 'Copy the URL',
                fields: [
                    {
                        type: 'textarea',
                        readOnly: true,
                        autoSelect: true,
                        value: url,
                        rows: 1,
                        style: {
                            textareaStyle: Object.assign({}, styleguide.inputfields.textArea.textareaStyle, {
                                color: '#000',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                overflow: 'hidden',
                            }),
                        },
                    },
                ],
            })
        })
    }
    showTouchShare(value) {
        this.setState({ selected: value.type })
    }
    hideTouchShare() {
        this.setState({ selected: null })
    }
    showMouseDownShare(value) {
        this.setState({ down: value.type })
    }

    getItemStyle(eventType, item) {
        if (item.type == this.state.down && eventType == 'mousedown') {
            return item.activeStyle
        }
        if (item.type == this.state.selected && eventType == 'mouseover') {
            return item.touchedStyle
        }
        return {}
    }

    render() {
        const { name, style } = this.props

        let tinyUrl = ''
        Utils.generateTinyURL(this.state.url, url => {
            tinyUrl = url
        })

        const message = 'Check out this virtual experience: ' + $('meta[property=og\\:title]').attr('content')
        const hashtags = ' #VirtualReality #VR' + (this.state.includeYouVisitHashtag ? ' #YouVisit' : '')
        const tagProps = {
            url: tinyUrl,
            appId: 89534166522,
            message: message + hashtags,
            windowOptions: ['status=0', 'toolbar=0', 'width=600', 'height=400'],
        }
        const buttons = {
            [SHARE_TYPES.email]: {
                action: this.showEmailForm,
                style: {
                    phone: {
                        width: '1.65em',
                        height: '1.1em',
                    },
                    desktop: {
                        width: '1em',
                        height: '0.7em',
                    },
                },
                hover: {
                    width: '1.1em',
                    height: '0.8em',
                },
                className: SHARE_TYPES.email,
            },
            [SHARE_TYPES.link]: {
                action: this.showLinkForm,
                style: {
                    phone: {
                        width: '1.75em',
                        height: '1.7em',
                    },
                    desktop: {
                        width: '1.25em',
                        height: '0.9em',
                    },
                },
                hover: {
                    width: '1.4em',
                    height: '0.95em',
                },
                className: SHARE_TYPES.link,
            },
            [SHARE_TYPES.twitter]: {
                tag: this.props.client.isClientApp ? asHybridButton(TwitterButton) : TwitterButton,
                tagProps,
                style: {
                    phone: {
                        width: '1.6em',
                        height: '1.45em',
                    },
                    desktop: {
                        width: '1.35em',
                        height: '0.9em',
                    },
                },
                hover: {
                    width: '1.4em',
                    height: '1em',
                },
                className: SHARE_TYPES.twitter,
            },
            [SHARE_TYPES.linkedin]: {
                tag: this.props.client.isClientApp ? asHybridButton(LinkedInButton) : LinkedInButton,
                tagProps,
                style: {
                    phone: {
                        width: '1.4em',
                        height: '1.4em',
                    },
                    desktop: {
                        width: '1.35em',
                        height: '0.9em',
                    },
                },
                hover: {
                    width: '1.4em',
                    height: '1em',
                },
                className: SHARE_TYPES.linkedin,
            },
            [SHARE_TYPES.facebook]: {
                tag: this.props.client.isClientApp ? asHybridButton(FacebookButton) : FacebookButton,
                tagProps,
                style: {
                    phone: {
                        width: '0.85em',
                        height: '1.75em',
                    },
                    desktop: {
                        width: '1.25em',
                        height: '1.1em',
                    },
                },
                hover: {
                    width: '1.3em',
                    height: '1.2em',
                },
                className: SHARE_TYPES.facebook,
            },
        }

        const list = Object.keys(buttons).map(key => {
            const { style, action, className, link, tag, tagProps, hover } = buttons[key]
            let keyStyle = Browser.phone() ? style.phone : style.desktop

            if (this.state.selected) {
                const selected = this.state.selected.split('_')
                const selectedKey = selected[1].toLowerCase()
                keyStyle = key === selectedKey ? hover : Browser.phone() ? style.phone : style.desktop
            }

            return {
                action,
                className,
                tag,
                tagProps,
                type: 'SHARE_' + key.toUpperCase(),
                touchedStyle: {
                    background: styleguide.colors.share[key],
                },
                activeStyle: {
                    background: styleguide.colors.share.active[key],
                },
                icon: {
                    name: 'share' + key.substr(0, 1).toUpperCase() + key.substr(1),
                    style: iconStyle(keyStyle),
                    link,
                },
            }
        }, this)

        return (
            <ContextMenu
                tabIndex={MENU_SHARE_MENU_INDEX}
                name={name ? name : SHARE_MENU}
                style={style}
                theme={Browser.phone() ? styleguide.contextMenu.share : styleguide.contextMenuDesktop.share}
                desktop={!Browser.phone()}
                allowScroll={!Browser.phone()}
                options={{
                    list,
                    onTouchStart: this.showTouchShare,
                    onTouchEnd: this.hideTouchShare,
                    onMouseOver: this.showTouchShare,
                    onMouseLeave: this.hideTouchShare,
                    onMouseDown: this.showMouseDownShare,
                    getItemStyle: this.getItemStyle,
                }}
            />
        )
    }
}

export default connect(
    mapSelectorsToProps([
        'trail',
        'trailsList',
        'pointIndex',
        'navigation',
        'language',
        'tourid',
        'location',
        'mainMedia',
        'client',
        'media',
        'contextMenu',
    ]),
    {
        openModal,
    }
)(ShareContextMenu)
